import { createSelector } from 'reselect';
import { selectFeatureFlag, selectIsGBUser } from '../../../reducers/selectors';
const EMPTY_ARTICLES = [];
export const selectHelpArticlesScreenConfigs = createSelector([
    (store) => selectFeatureFlag(store, 'help_articles_config'),
    (_store, articlesKey) => articlesKey,
    selectIsGBUser,
], (featureFlag, articlesKey, isGBUser) => {
    if (featureFlag.value && featureFlag.extra && articlesKey) {
        const screenConfig = featureFlag.extra?.screens?.[articlesKey];
        if (!isGBUser && screenConfig?.categoryIdUs) {
            const { categoryIdUs, ...rest } = screenConfig;
            return { ...rest, categoryId: categoryIdUs };
        }
        return screenConfig;
    }
    return undefined;
});
export const selectHelpMoreArticles = createSelector([
    (store) => selectFeatureFlag(store, 'help_articles_config'),
    (_store, moreArticlesKey) => moreArticlesKey,
], (featureFlag, moreArticlesKey) => {
    if (featureFlag.value && featureFlag.extra && moreArticlesKey)
        return featureFlag.extra?.moreArticles?.[moreArticlesKey];
    return undefined;
});
export const selectFlagHelpArticles = createSelector([(store) => selectFeatureFlag(store, 'help_articles_config'), selectIsGBUser], (featureFlag, isGBUser) => {
    if (featureFlag.value && featureFlag.extra) {
        const articles = {};
        Object.entries(featureFlag.extra?.articles ?? {}).forEach(([key, article]) => {
            const typedArticle = article;
            let localizedUrl;
            if (isGBUser) {
                localizedUrl = typedArticle.url;
            }
            else if (typedArticle.url_us) {
                localizedUrl = typedArticle.url_us;
            }
            // Only include article if BOTH title AND url exist
            if (localizedUrl && typedArticle.title) {
                articles[key] = {
                    article_id: key,
                    // Use customTitle if it exists, otherwise fall back to title
                    title: typedArticle.customTitle || typedArticle.title,
                    url: localizedUrl,
                };
            }
        });
        if (Object.keys(articles).length > 0) {
            return articles;
        }
        return undefined;
    }
    return undefined;
});
export const selectHelpArticlesByCategory = createSelector([
    (store) => store.helpArticles.articles,
    (_store, categoryId) => categoryId,
], (articles, categoryId) => {
    if (!categoryId) {
        return EMPTY_ARTICLES;
    }
    return articles?.[categoryId] ?? EMPTY_ARTICLES;
});
export const selectIsFetchingCategory = (store) => store.helpArticles.isFetchingCategory;
